import axios from "./httpClient";
import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { IASEntry, IASEntryCreateParams } from "../models/shortage";
import { throwApiError } from "./apiError";
import { getTrackingHeadersMap } from "./getTrackingHeaders";

/**
 * CRETE API call using Axios
 * @returns - Create shortage entry and return same object
 */

export const CreateShortageEntryAPI = async (params: IASEntryCreateParams): Promise<IASEntry> => {
  try {
    // Get static headers from map
    const staticHeaders = getTrackingHeadersMap(ApiType.SHORTAGE_ENTRY_CREATE) || {};
    // Add dynamic terminal values
    const headers = {
      ...staticHeaders,
      "OSD-Reporting-Terminal": params.reporting,
      "OSD-Origin-Terminal": params.origin,
      "OSD-Destination-Terminal": params.destination,
    };
    const response = await axios.post(getUrl(ApiType.SHORTAGE_ENTRY_CREATE), params, { headers });
    return response.data;
  } catch (error: any) {
    return throwApiError(error, ErrorMessages.createShortageEntry, { badRequestOrder: "errorsFirst" });
  }
};
